export const GET_CATEGORIES_LIST = 'GET_CATEGORIES_LIST'
export const SET_CATEGORIES_LIST = 'SET_CATEGORIES_LIST'
export const ADD_NEW_CATEGORY = 'ADD_NEW_CATEGORY'
export const EDIT_CATEGORY = 'EDIT_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const GET_SUB_CATEGORIES = 'GET_SUB_CATEGORIES'
export const SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES'
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE'
